'use strict';

const Fields = [
    'firstName',
    'lastName',
    'company',
    'line1',
    'line2',
    'country',
    'city',
    'state',
    'zipCode',
    'phoneNumber',
];

export { Fields };
